module.exports = __webpack_public_path__ + "static/media/preview.f6320800.webp";